import httpRequest from 'httpRequest'
import { UserPreferenceContract } from 'models'
import userService from 'Services/api/user.service'
import authService from 'Services/api/auth.service'
import { AppThunk, createDispatchActionSet } from './base.action'

export const ACTION_CODE_STORAGE_KEY = 'moduleActions'

export const LOGIN_BEGIN = 'LOGIN_BEGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const AUTH_EXPIRED = 'AUTH_EXPIRED'
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
export const SHOW_FORCE_LOGOUT_DIALOG = 'SHOW_FORCE_LOGOUT_DIALOG'

export enum ERefreshTokenExpired {
    RefreshTokenExpired = '1',
    OtherError = '2',
}

export const setIsAuthExpired = (
    message: string = 'Your session has expired.',
    status?: any,
    needLogout?: boolean,
): AppThunk => (dispatch) => {
    if (needLogout ?? true) {
        dispatch(logout())
    }
    dispatch({
        type: AUTH_EXPIRED,
        payload: message + `${status ? ' (' + status + ')' : ''}`,
    })
}
export const getUserDataActionSet = createDispatchActionSet<any>(
    'AUTH_GET_USER_DATA',
)

export function getEncryptionKey(encodedValue: string) {
    var words = atob(encodedValue)
    return JSON.parse(words)
}

/**
 * Dispatch this event after success fetching real access token.
 * Caller must pass
 * 1) user's action codes
 * 2) user's data in type `UserDataContract`
 */
export const COMPLETE_FETCH_FULL_ACCESS_TOKEN =
    'COMPLETE_FETCH_FULL_ACCESS_TOKEN'
export const COMPLETE_FETCH_PERMISSION = 'COMPLETE_FETCH_PERMISSION'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export function logout() {
    return async (dispatch: any) => {
        try {
            await authService.logout()
        } catch {
            console.info('logged out while token is expired')
        } finally {
            httpRequest.deleteAuthorizationCookies()
            dispatch(logoutSuccess())
        }
    }
}

const logoutSuccess = () => ({
    type: LOGOUT_SUCCESS,
})

export const UPDATE_USERPREFERENCE_BEGIN = 'UPDATE_USERPREFERENCE_BEGIN'
export const UPDATE_USERPREFERENCE_SUCCESS = 'UPDATE_USERPREFERENCE_SUCCESS'
export const UPDATE_USERPREFERENCE_FAILURE = 'UPDATE_USERPREFERENCE_FAILURE'

export const PutUserPrefernece = (body: UserPreferenceContract) => async (
    dispatch: any,
) => {
    dispatch({
        type: UPDATE_USERPREFERENCE_BEGIN,
    })

    return userService
        .setUserPreference(body)
        .then(() => {
            dispatch({
                type: UPDATE_USERPREFERENCE_SUCCESS,
                payload: body,
            })
        })
        .catch((err: any) => {
            dispatch({
                type: UPDATE_USERPREFERENCE_FAILURE,
                err,
            })
        })
}
